import { Component, OnInit, Input } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';

@Component({
  selector: 'itpx-product-details-variants',
  templateUrl: './product-details-variants.component.html',
  styleUrls: ['./product-details-variants.component.css']
})
export class ProductDetailsVariantsComponent {

    @Input()
    private productSKU: string;
    private url: string;
    private detailsRoute: string = '/agora/product-data/product-variants/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Name',
            name: 'name',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Delivery Format',
            name: 'deliveryFormat.configValue',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Language',
            name: 'language.configValue',
        }, {
            title: 'Certificate Type',
            name: 'certificateType.configValue'
        }
    ];

    constructor( private configService: ConfigService ) {
    }

    ngOnInit() {
        this.url = this.configService.get('server').url +
            this.configService.get('endpoints').agora.productVariants.listByProductSKU.api + '/' +
            this.productSKU;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/details/product-details-variants/product-details-variants.component.ts